<template>
  <router-link :to="link" class="nu">
    <div class="hero is-fullwidth is-large has-background">
      <transition name="fade">
        <img
          v-show="ready"
          :alt="title"
          class="hero-background is-transparent hero-sm custom-img"
          :src="`${image}?size=2000`"
          @load="
            ready = true;
            $emit('ready');
          "
        />
      </transition>

      <div class="hero-body np">
        <div class="container">
          <h1 v-if="title" class="title has-text-light">{{ title }}</h1>
          <h2 v-if="subtitle" class="subtitle has-text-light">
            {{ subtitle }}
          </h2>
        </div>
      </div>
    </div>
  </router-link>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.custom-img {
  object-fit: cover;
}
</style>

<script>
export default {
  components: {},
  props: ["link", "image", "title", "subtitle"],
  data() {
    return {
      ready: false,
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
